import React from 'react';
import styles from './PrivacyPolicyPage.module.css';

type PrivacyPolicyContentProps = {
  className?: string;
};

export const PrivacyPolicyContent: React.FC<PrivacyPolicyContentProps> = ({ className }) => (
  <div className={`${styles.content} ${className ?? ''}`}>
    <h1>Chính sách quyền riêng tư</h1>
    <p className={styles.lead}>
      <strong>S HRM</strong>
      <br />
      CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN
      <br />
      Cập nhật lần cuối: 20/08/2026
    </p>
    <p>
      Chính sách bảo mật này áp dụng cho tất cả người dùng sử dụng S HRM, bao gồm người dùng nội bộ của CÔNG TY TNHH
      CÔNG NGHỆ RỒNG BIỂN và người dùng thuộc các tổ chức khác được cấp quyền truy cập theo hợp đồng dịch vụ ký kết với
      CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN. Việc sử dụng ứng dụng đồng nghĩa với việc chấp nhận chính sách này.
    </p>

    <h3>1. Đối tượng áp dụng</h3>
    <p>Chính sách này áp dụng cho hai nhóm người dùng:</p>
    <p>
      <strong>Người dùng nội bộ:</strong>
    </p>
    <ul>
      <li>Nhân viên và quản lý của CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN được cấp tài khoản sử dụng hệ thống.</li>
    </ul>
    <p>
      <strong>Người dùng bên ngoài:</strong>
    </p>
    <ul>
      <li>
        Các tổ chức, doanh nghiệp sử dụng S HRM theo hợp đồng dịch vụ ký kết với CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN và
        nhân viên của các tổ chức đó được cấp tài khoản bởi chính tổ chức họ.
      </li>
      <li>
        Tổ chức bên ngoài chỉ được phép sử dụng S HRM sau khi ký hợp đồng dịch vụ với CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN.
        Hợp đồng đó sẽ quy định thêm các điều khoản riêng về dữ liệu, bảo mật và trách nhiệm giữa hai bên.
      </li>
    </ul>

    <h3>2. Thông tin được thu thập</h3>
    <p>
      <strong>Thông tin tài khoản:</strong>
    </p>
    <ul>
      <li>Email và mật khẩu đăng nhập.</li>
      <li>Lịch sử đăng nhập: thời gian, loại thiết bị, địa chỉ IP.</li>
    </ul>
    <p>
      <strong>Dữ liệu chấm công:</strong>
    </p>
    <ul>
      <li>Thời gian check-in và check-out hàng ngày.</li>
      <li>Tọa độ GPS tại thời điểm chấm công (chỉ trên ứng dụng di động).</li>
      <li>Trạng thái: đúng giờ, đi trễ, về sớm, vắng mặt.</li>
    </ul>
    <p>
      <strong>Thông tin kỹ thuật:</strong>
    </p>
    <ul>
      <li>Loại thiết bị, phiên bản hệ điều hành, phiên bản ứng dụng.</li>
      <li>Nhật ký lỗi kỹ thuật.</li>
    </ul>

    <h3>3. Mục đích sử dụng thông tin</h3>
    <ul>
      <li>Xác minh danh tính và kiểm soát quyền truy cập hệ thống.</li>
      <li>Ghi nhận và quản lý dữ liệu chấm công, ngày công.</li>
      <li>Xác minh vị trí làm việc khi thực hiện chấm công GPS.</li>
      <li>Hỗ trợ kỹ thuật và cải thiện hiệu năng ứng dụng.</li>
    </ul>
    <p>
      CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN không sử dụng thông tin người dùng cho mục đích quảng cáo, phân tích thương mại
      hoặc bất kỳ mục đích nào ngoài việc vận hành hệ thống HRM.
    </p>

    <h3>4. Dữ liệu vị trí GPS</h3>
    <p>
      S HRM chỉ thu thập vị trí GPS đúng tại thời điểm người dùng chấm công. Không theo dõi vị trí liên tục, không ghi lộ
      trình di chuyển, không truy cập vị trí khi ứng dụng đang chạy nền.
    </p>
    <ul>
      <li>Android: Quyền ACCESS_FINE_LOCATION — chỉ khi đang mở ứng dụng.</li>
      <li>iOS: Quyền vị trí "Khi đang dùng ứng dụng" (When In Use).</li>
      <li>
        Người dùng có thể tắt quyền GPS trong Cài đặt điện thoại bất cứ lúc nào. Khi đó tính năng chấm công GPS sẽ không
        hoạt động — đây là giới hạn kỹ thuật của tính năng, không phải lỗi hệ thống.
      </li>
      <li>Dữ liệu GPS không được chia sẻ ra ngoài hệ thống.</li>
    </ul>

    <h3>5. Chia sẻ thông tin</h3>
    <p>
      CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN không bán, không cho thuê và không chia sẻ dữ liệu người dùng với mục đích thương
      mại. Thông tin chỉ được truy cập bởi:
    </p>
    <ul>
      <li>Bộ phận Nhân sự: Xem và quản lý dữ liệu chấm công, ngày công.</li>
      <li>Quản lý: Xem dữ liệu chấm công của nhân viên thuộc quyền quản lý.</li>
      <li>Bộ phận Kế toán: Dữ liệu phục vụ tính lương.</li>
      <li>Bộ phận IT: Nhật ký kỹ thuật để xử lý sự cố.</li>
      <li>Nhà cung cấp hạ tầng đám mây: Lưu trữ dữ liệu theo hợp đồng bảo mật — không được sử dụng dữ liệu ngoài mục đích lưu trữ.</li>
    </ul>

    <h3>6. Bảo mật dữ liệu</h3>
    <ul>
      <li>Toàn bộ dữ liệu truyền giữa ứng dụng và máy chủ được mã hoá bằng HTTPS/TLS.</li>
      <li>Mật khẩu được băm một chiều (hash) — không lưu dạng văn bản, không thể khôi phục nguyên bản.</li>
      <li>Phân quyền truy cập theo vai trò — mỗi người chỉ xem được dữ liệu phù hợp chức vụ.</li>
      <li>Dữ liệu được sao lưu định kỳ tự động.</li>
    </ul>
    <p>
      CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN áp dụng các biện pháp bảo mật hợp lý theo tiêu chuẩn kỹ thuật. CÔNG TY TNHH CÔNG
      NGHỆ RỒNG BIỂN không chịu trách nhiệm về thiệt hại phát sinh từ các sự cố nằm ngoài tầm kiểm soát như tấn công mạng
      từ bên ngoài, lỗi của nhà cung cấp hạ tầng, hoặc hành vi sai trái của chính người dùng.
    </p>

    <h3>7. Quyền của người dùng</h3>
    <ul>
      <li>Xem lại dữ liệu chấm công cá nhân trực tiếp trong ứng dụng.</li>
      <li>Yêu cầu chỉnh sửa thông tin sai — liên hệ bộ phận HR hoặc quản lý.</li>
      <li>Yêu cầu xóa tài khoản và dữ liệu khi không còn sử dụng.</li>
      <li>Tắt quyền truy cập GPS bất kỳ lúc nào trong Cài đặt thiết bị.</li>
    </ul>
    <p>
      Người dùng thuộc tổ chức bên ngoài thực hiện các yêu cầu trên thông qua bộ phận HR của tổ chức mình — không trực
      tiếp với CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN, trừ khi hợp đồng dịch vụ quy định khác.
    </p>

    <h3>8. Thời gian lưu trữ dữ liệu</h3>
    <p>
      Dữ liệu được lưu trữ trong thời gian tài khoản còn hoạt động hoặc trong thời hạn cần thiết để cung cấp dịch vụ,
      thực hiện nghĩa vụ theo hợp đồng và tuân thủ quy định pháp luật. Khi tài khoản hoặc hợp đồng chấm dứt, yêu cầu
      xóa dữ liệu sẽ được xử lý theo quy trình của tổ chức quản lý tài khoản và các nghĩa vụ lưu trữ áp dụng.
    </p>

    <h3>9. Điều khoản riêng với tổ chức, doanh nghiệp sử dụng theo hợp đồng</h3>
    <p>
      Phần này áp dụng cho các tổ chức, doanh nghiệp sử dụng S HRM theo hợp đồng dịch vụ ký kết với CÔNG TY TNHH CÔNG NGHỆ
      RỒNG BIỂN.
    </p>
    <ul>
      <li>
        Tổ chức, doanh nghiệp sử dụng dịch vụ phải ký hợp đồng với CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN trước khi được cấp
        quyền truy cập. Hợp đồng có thể bổ sung thêm điều khoản riêng về dữ liệu và bảo mật.
      </li>
      <li>Dữ liệu của mỗi tổ chức được lưu trữ riêng biệt với dữ liệu của tổ chức khác.</li>
      <li>
        Tổ chức, doanh nghiệp chịu trách nhiệm thông báo cho nhân viên của mình về việc dữ liệu được thu thập và xử lý khi
        sử dụng hệ thống.
      </li>
      <li>
        Tổ chức, doanh nghiệp chịu trách nhiệm quản lý tài khoản nhân viên: tạo tài khoản, vô hiệu hoá kịp thời khi nhân
        viên nghỉ việc.
      </li>
      <li>
        Khi hợp đồng kết thúc, tổ chức, doanh nghiệp có 30 ngày để xuất toàn bộ dữ liệu của mình. Sau thời hạn này, dữ liệu
        sẽ bị xóa vĩnh viễn. CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN không chịu trách nhiệm nếu tổ chức, doanh nghiệp không thực
        hiện xuất dữ liệu trong thời hạn trên.
      </li>
    </ul>
    <p>
      CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN không chịu trách nhiệm về thiệt hại phát sinh từ việc tổ chức, doanh nghiệp sử dụng
      dịch vụ không đúng mục đích, cấu hình sai hệ thống, hoặc không thực hiện đúng các trách nhiệm quản lý nêu trên.
    </p>

    <h3>10. Thay đổi chính sách</h3>
    <ul>
      <li>CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN có quyền cập nhật, thay đổi chính sách bảo mật này khi cần thiết.</li>
      <li>
        Việc tiếp tục sử dụng ứng dụng sau khi có cập nhật hoặc thay đổi chính sách bảo mật đồng nghĩa với việc người dùng
        chấp nhận các cập nhật, thay đổi đó.
      </li>
      <li>
        Tổ chức, doanh nghiệp không đồng ý với việc cập nhật hoặc các thay đổi liên quan đến chính sách bảo mật có quyền
        chấm dứt hợp đồng dịch vụ theo Hợp đồng dịch vụ đã ký với CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN.
      </li>
    </ul>

    <h3>11. Thông tin liên hệ</h3>
    <p>Mọi thắc mắc về chính sách bảo mật, vui lòng liên hệ:</p>
    <table className={styles.contactTable}>
      <tbody>
        <tr>
          <th>Đơn vị phát triển</th>
          <td>CÔNG TY TNHH CÔNG NGHỆ RỒNG BIỂN</td>
        </tr>
        <tr>
          <th>Email hỗ trợ</th>
          <td>congngherongbien@gmail.com</td>
        </tr>
        <tr>
          <th>Website</th>
          <td>
            <a href="https://sdtc.vn" target="_blank" rel="noreferrer">
              sdtc.vn
            </a>
          </td>
        </tr>
        <tr>
          <th>Điện thoại</th>
          <td>0931 494 389</td>
        </tr>
      </tbody>
    </table>
    <p>
      Người dùng thuộc tổ chức bên ngoài có thắc mắc về dữ liệu cá nhân, đề nghị liên hệ trực tiếp với quản lý hoặc bộ phận
      có liên quan của tổ chức mình đã cấp tài khoản.
    </p>
  </div>
);

export const PrivacyPolicyPage: React.FC = () => (
  <div className={styles.page}>
    <header className={styles.header}>
      <a className={styles.brand} href="/" aria-label="S HRM - Trang chủ">
        <span className={styles.brandMark}>S</span>
        <span>
          <strong>S HRM</strong>
          <small>Sea Dragon Technology</small>
        </span>
      </a>
      <a className={styles.backLink} href="/login">
        Quay lại đăng nhập
      </a>
    </header>

    <main className={styles.main}>
      <PrivacyPolicyContent />
    </main>

    <footer className={styles.footer}>
      © 2026 Công ty TNHH Công nghệ Rồng Biển. Mọi quyền được bảo lưu.
    </footer>
  </div>
);
